import HeaderBar from "../../../Components/UI/headerbar";
import SpecialOffersTab from "../components/SpecialOffersTab";

const SpecialOffersPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar title="التسويق" content="إدارة الكوبونات والعروض والبانرات." />

      <div className="mt-4">
        <SpecialOffersTab />
      </div>
    </div>
  );
};

export default SpecialOffersPage;
